export default "__VITE_ASSET__B_oSvAb4__"